/** LeadDetailRoute — skin-aware switcher for /pipeline/:id. */
import { useUISkin } from "@/data/UISkinContext";
import LeadDetail from "./LeadDetail";
import { CockpitFrame } from "@/components/cockpit/CockpitFrame";

export default function LeadDetailRoute() {
  const { skin } = useUISkin();
  if (skin === "cockpit") {
    return (
      <CockpitFrame title="Lead Detail">
        <LeadDetail />
      </CockpitFrame>
    );
  }
  return <LeadDetail />;
}
